import { useState } from "react";
import Radio from "./Radio";

## Basic Usage

export function BasicRadio() {
  const [selected, setSelected] = useState("option1");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      <Radio
        name="basic"
        value="option1"
        label="Option 1"
        checked={selected === "option1"}
        onChange={() => setSelected("option1")}
      />
      <Radio
        name="basic"
        value="option2"
        label="Option 2"
        checked={selected === "option2"}
        onChange={() => setSelected("option2")}
      />
      <Radio
        name="basic"
        value="option3"
        label="Option 3"
        checked={selected === "option3"}
        onChange={() => setSelected("option3")}
      />
    </div>
  );
}

<BasicRadio />

---

## Without Labels

<div style={{ display: "flex", gap: "1rem" }}>
  <Radio name="no-label" value="a" defaultChecked />
  <Radio name="no-label" value="b" />
  <Radio name="no-label" value="c" />
</div>

---

## Disabled State

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <Radio name="disabled" value="1" label="Enabled option" />
  <Radio name="disabled" value="2" label="Disabled unchecked" disabled />
  <Radio name="disabled" value="3" label="Disabled checked" disabled checked />
</div>

---

## Locked State

<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
  <Radio name="locked" value="1" label="Normal option" />
  <Radio name="locked" value="2" label="Locked option" iconLock checked />
</div>

The locked state shows a lock icon indicating the value cannot be changed.

---

## Controlled Selection

export function ControlledRadio() {
  const [plan, setPlan] = useState("basic");
  const plans = [
    { value: "basic", label: "Basic Plan - Free" },
    { value: "pro", label: "Pro Plan - $9/mo" },
    { value: "enterprise", label: "Enterprise - Contact us" },
  ];
  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {plans.map((p) => (
          <Radio
            key={p.value}
            name="plan"
            value={p.value}
            label={p.label}
            checked={plan === p.value}
            onChange={() => setPlan(p.value)}
          />
        ))}
      </div>
      <p style={{ marginTop: "0.75rem" }}>Selected: **{plan}**</p>
    </div>
  );
}

<ControlledRadio />

---

## Horizontal Layout

export function HorizontalRadio() {
  const [size, setSize] = useState("medium");
  return (
    <div style={{ display: "flex", gap: "1.5rem" }}>
      <Radio name="size" value="small" label="Small" checked={size === "small"} onChange={() => setSize("small")} />
      <Radio name="size" value="medium" label="Medium" checked={size === "medium"} onChange={() => setSize("medium")} />
      <Radio name="size" value="large" label="Large" checked={size === "large"} onChange={() => setSize("large")} />
    </div>
  );
}

<HorizontalRadio />


